import { Link } from "react-router-dom";
import { MessageSquareWarning, ShieldCheck, Sparkles, Copy, Scale, Eye, Ban, ArrowUpRight } from "lucide-react";
import { PageHeader, Panel } from "@/components/Shared";

const STEPS = [
  { icon: MessageSquareWarning, t: "Anexe a reclamação", d: "Cole o texto ou o print da avaliação, cancelamento ou reembolso solicitado pelo cliente." },
  { icon: ShieldCheck, t: "Adicione suas provas", d: "Foto do pedido antes da coleta, lacre, comanda, comprovantes e registros de expedição." },
  { icon: Sparkles, t: "Os fatos são confrontados", d: "Cada alegação é comparada com as provas e o cardápio. Contradições objetivas são destacadas." },
  { icon: Copy, t: "Copie e envie", d: "Receba motivo e submotivo sugeridos e um texto dentro do limite de caracteres da plataforma." },
];
const PRINCIPLES = [
  { icon: Ban, t: "Nada é inventado", d: "A defesa usa somente o que está no caso e nas imagens. Se falta prova, você é avisado." },
  { icon: Scale, t: "Sem acusações sem prova", d: "Entregador, cliente ou plataforma nunca são acusados sem evidência objetiva." },
  { icon: Eye, t: "Força é estimativa", d: "A porcentagem mede a força das evidências, não a probabilidade oficial de aprovação." },
];

export default function HowItWorks() {
  return (
    <div className="fade-up space-y-6" data-testid="how-it-works-page">
      <PageHeader eyebrow="Guia" title="Como funciona" desc="Do print da reclamação ao recurso pronto em poucos minutos." />
      <div className="grid gap-4 md:grid-cols-4">
        {STEPS.map((s, i) => (
          <Panel key={s.t}>
            <div className="flex items-center justify-between"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-amber-50"><s.icon className="h-5 w-5 text-amber-600" /></span><span className="font-display text-3xl font-extrabold text-slate-200">0{i + 1}</span></div>
            <p className="mt-4 font-display font-bold text-slate-900">{s.t}</p><p className="mt-1 text-sm text-slate-500">{s.d}</p>
          </Panel>
        ))}
      </div>
      <section className="rounded-3xl bg-slate-900 p-7 text-white">
        <h2 className="font-display text-2xl font-extrabold">Quem avalia uma reclamação nas plataformas de delivery?</h2>
        <p className="mt-3 max-w-3xl text-sm leading-relaxed text-white/75">A plataforma não informa publicamente todos os detalhes do fluxo. Pode haver análise automática e revisão humana em diferentes etapas. Por isso, o Contestafood não presume o decisor: ele foca em fatos, coerência e provas verificáveis — um texto claro e objetivo funciona tanto para leitura automatizada quanto humana.</p>
      </section>
      <div className="grid gap-4 md:grid-cols-3">
        {PRINCIPLES.map((p) => (
          <Panel key={p.t} title={p.t} icon={p.icon}><p className="text-sm text-slate-500">{p.d}</p></Panel>
        ))}
      </div>
      <Link to="/nova-analise" data-testid="how-start-btn" className="ai-cta inline-flex h-12 items-center gap-2 rounded-xl px-6 font-semibold text-white">Começar uma análise <ArrowUpRight className="h-4 w-4" /></Link>
    </div>
  );
}
